/**
 * @desc 新增
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.SalesOwnerInfoRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/salesOwnerInfo/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
